import { render, staticRenderFns } from "./PushNotification.vue?vue&type=template&id=1468c1f1&"
import script from "./PushNotification.vue?vue&type=script&lang=js&"
export * from "./PushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports